import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LifeInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { lifeInsurancePossessed: lifeInsurancePossessed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('have_life_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Life Insurance"
          subHeader=" Life insurance pays your family a specified lump sum of money when you
          pass away."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader header="Do you have life insurance?" />
        <Formik
          initialValues={{ lifeInsurancePossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema('lifeInsurancePossessed')}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator
              name="lifeInsurancePossessed"
              showNotSure={true}
            />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { LifeInsuranceStep };
